export const PROFIT_SHARING_FIELDS = Object.freeze([
  'tier1Threshold',
  'tier2Threshold',
  'tier3Threshold',
  'tier2StewardRatio',
  'tier2RpRatio',
  'tier2PuskudRatio',
  'tier3StewardRatio',
  'tier3RpRatio',
  'tier3PuskudRatio',
  'tier4StewardRatio',
  'tier4RpRatio',
  'tier4PuskudRatio'
]);

export const DEFAULT_PROFIT_SHARING_CONFIG = Object.freeze({
  tier1Threshold: 17010,
  tier2Threshold: 56700,
  tier3Threshold: 94500,
  tier2StewardRatio: 20,
  tier2RpRatio: 70,
  tier2PuskudRatio: 10,
  tier3StewardRatio: 10,
  tier3RpRatio: 35,
  tier3PuskudRatio: 5,
  tier4StewardRatio: 10,
  tier4RpRatio: 35,
  tier4PuskudRatio: 5
});

export const normalizeProfitSharingDefaults = (value = {}) => (
  PROFIT_SHARING_FIELDS.reduce((result, field) => {
    const numeric = Number(value[field]);
    result[field] = Number.isFinite(numeric)
      ? numeric
      : DEFAULT_PROFIT_SHARING_CONFIG[field];
    return result;
  }, {})
);

export const getProfitSharingRatioTotals = (config) => ({
  tier2: Number(config.tier2StewardRatio) + Number(config.tier2RpRatio) + Number(config.tier2PuskudRatio),
  tier3: Number(config.tier3StewardRatio) + Number(config.tier3RpRatio) + Number(config.tier3PuskudRatio),
  tier4: Number(config.tier4StewardRatio) + Number(config.tier4RpRatio) + Number(config.tier4PuskudRatio)
});

export const validateProfitSharingDefaults = (value = {}) => {
  const normalized = {};
  for (const field of PROFIT_SHARING_FIELDS) {
    const numeric = Number(value[field]);
    if (!Number.isFinite(numeric)) {
      return { valid: false, code: 'number', field };
    }
    normalized[field] = numeric;
  }

  if (normalized.tier1Threshold <= 0
    || normalized.tier1Threshold >= normalized.tier2Threshold
    || normalized.tier2Threshold >= normalized.tier3Threshold) {
    return { valid: false, code: 'thresholds' };
  }

  const invalidRatio = PROFIT_SHARING_FIELDS
    .filter((field) => field.endsWith('Ratio'))
    .find((field) => normalized[field] < 0 || normalized[field] > 100);
  if (invalidRatio) return { valid: false, code: 'ratioRange', field: invalidRatio };

  const totals = getProfitSharingRatioTotals(normalized);
  if (totals.tier2 !== 100) return { valid: false, code: 'tier2Total', totals };
  if (totals.tier3 !== 50) return { valid: false, code: 'tier3Total', totals };
  if (totals.tier4 !== 50) return { valid: false, code: 'tier4Total', totals };

  return { valid: true, config: normalized, totals };
};

export const isProfitSharingConfigDirty = (current, saved) => (
  PROFIT_SHARING_FIELDS.some((field) => Number(current?.[field]) !== Number(saved?.[field]))
);
